import { Directive, TemplateRef } from '@angular/core';

// Marks an <ng-template> as the table footer (e.g. an aggregation/totals row).
// Usage: <ng-template appTableFooter><tr>...</tr></ng-template>
@Directive({ selector: '[appTableFooter]' })
export class TableFooterDirective {
	constructor(public template: TemplateRef<any>) {}
}
